module.exports = __webpack_public_path__ + "static/media/quote.2a57229a.svg";